class AvailabilityReleaseStrategyCtrl {
    constructor(borderColor, $sce) {
        'ngInject';

        this.borderColor = borderColor
        this.MIN = 1
        this.MAX = 60;

        this.inOrderPopupInfo = $sce.trustAsHtml(doclrVertaal.instant('availabilityRelease.inorder.popup.info'));
        this.timeBoundImmediatePopupInfo = $sce.trustAsHtml(doclrVertaal.instant('availabilityRelease.timebound.immediate.popup.info'));
        this.timeBoundSameDayPopupInfo = $sce.trustAsHtml(doclrVertaal.instant('availabilityRelease.timebound.sameday.popup.info'));
        this.timeBoundXDaysPopupInfo = $sce.trustAsHtml(doclrVertaal.instant('availabilityRelease.timebound.xdays.popup.info'));

        this.releaseBeforeEnum = {
            immediate:  'immediate',
            sameDay: 'sameDay',
            xDaysBefore: 'xDaysBefore'
        };

        // this.availibility is injected
        this.groepen = ['#7EA0B9', '#BFAE50', '#61A953', '#A64C4C'];
        this.volgnummers = [1, 2, 3, 4];
    }

    updateVolgnummers(offset) {
        this.volgnummers = this.volgnummers.map(volgnummer => {
            var nextVolgnummer = volgnummer + offset;
            return (nextVolgnummer < this.MIN || nextVolgnummer > this.MAX) ? volgnummer : nextVolgnummer;
        });
    };

    unsetReleaseInOrder(){
        this.availabilityReleaseStrategy.inOrderRelease = InOrderRelease.createNotDefined();
        this.autoConfirm();
        $event.stopPropagation();
    }

    selectInVolgorde(groep, volgnummer, $event) {
        this.availabilityReleaseStrategy.inOrderRelease = InOrderRelease.create(volgnummer, groep);
        this.autoConfirm();
        $event.stopPropagation();
    };

    selectReleaseImmediate() {
        this.availabilityReleaseStrategy.timeBoundRelease = TimeBoundRelease.createImmediate();
        this.autoConfirm();

    };
    selectReleaseSameDay() {
        this.availabilityReleaseStrategy.timeBoundRelease = TimeBoundRelease.create(0);
        this.autoConfirm();
    };

    selectReleaseXDaysBefore() {
        if(!this.availabilityReleaseStrategy.timeBoundRelease.isXDays())
        {
            this.availabilityReleaseStrategy.timeBoundRelease = TimeBoundRelease.create(1);
        }
    };

    hasConfirm(){
        return angular.isDefined(this.onConfirm) && this.onConfirm;
    }

    isSelectedOrder(number, group){
        return this.availabilityReleaseStrategy.inOrderRelease.isDefined &&
            this.availabilityReleaseStrategy.inOrderRelease.number === number &&
            this.availabilityReleaseStrategy.inOrderRelease.group === group;
    }

    autoConfirm(){
        if(this.hasConfirm()){
            this.confirm();
        }
    }

    confirm(){
        this.onConfirm()(this.availabilityReleaseStrategy);
    }

    isMaximum() {
        return _.max(this.volgnummers) >= this.MAX;
    };

    isMinimum() {
        return _.min(this.volgnummers) <= this.MIN;
    };

    getBorderColor(color) {
        color ? this.borderColor(color) : '#ccc';
    };

}

(function () {
    'use strict';

    angular.module('doclr.availabilityReleaseStrategy')
        .component('availabilityReleaseStrategyEdit', {
            templateUrl: '/partials/beschikbaarheidtypes/availabilityReleaseStrategy.edit.component.html',
            controller: AvailabilityReleaseStrategyCtrl,
            controllerAs: 'availabilityReleaseStrategyVM',
            bindings: {
                availabilityReleaseStrategy: '=',
                onConfirm: '&?'
            }
        });
})();
